import React from 'react';
export function TruckIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 7H16V5a1 1 0 00-1-1H1a1 1 0 00-1 1v13a1 1 0 001 1h2.17a3.001 3.001 0 005.66 0h6.34a3.001 3.001 0 005.66 0H23a1 1 0 001-1v-4l-2-3-1.5-4zM16 9h3.114l.75 2H16V9zm-2-3H2v11h1.17a3.001 3.001 0 015.66 0h6.34a3.001 3.001 0 015.66 0H22v-2.394L20.93 13H14V6zM7 18a1 1 0 11-2 0 1 1 0 012 0zm11 1a1 1 0 100-2 1 1 0 000 2z"
  }));
}